import Link from 'next/link'

const Header = (props) => {
  return (
    <div className='image-brand'>
      <Link href='/' >
        <a className='image-brand__image'>
          <img src='/images/logo.png' alt="Logo Flirt Bees" />
        </a>
      </Link>
    </div>
  )
}
export default Header
